import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import FavoriteProducts from "../components/FavoriteProducts";


const FavoriteProductsPage = () => {
    const [showPage, setShowPage] = useState(false);
    const navigate = useNavigate();



    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
            setShowPage(true)
        }
        else {
            navigate('/unauthorize', { replace: true });
        }

    }, []);



    return (
        <React.Fragment >
            {showPage ?
                <FavoriteProducts />
                : ''
            }

        </React.Fragment>
    );
};

export default FavoriteProductsPage;